import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useEffect, useState } from 'react'
import styles from './UserAvatar.module.scss'

export const getUserAvatarUrl = user => user?.avatar_url || user?.photo_url || user?.image || user?.imeag || ''

export default function UserAvatar({ user, className = '', size, alt = tr("Фото профиля") }) {
  useInterfaceLanguage();
  const source = getUserAvatarUrl(user)
  const [failed, setFailed] = useState(false)
  useEffect(() => { setFailed(false) }, [source])
  const initials = [user?.surName || user?.surname, user?.firstName || user?.first_name]
    .filter(Boolean).map(value => value[0]).join('').slice(0, 2) || tr("КК")
  return <span className={`${styles.avatar} ${className}`} style={size ? { width: size, height: size, fontSize: Math.max(12, size / 3) } : undefined}>
    {source && !failed ? <img src={source} alt={tr(alt)} onError={() => setFailed(true)} /> : <span role="img" aria-label={tr(alt)}>{tr(initials)}</span>}
  </span>
}
